export enum Typology {
	TECHNOLOGY_PROVIDER= "Technology Provider",
	TECHNOLOGY_USER= "Technology User",
	INTERMEDIARY_ORG= "Intermediary Org",
	FUNDING = "Funding",
}



// WEBPACK FOOTER //
// ./Frontend/src/entity/Typology.ts